<div class="sideStyle">
  <div style="height: 100vh; width: 53px; min-width: 53px;" class="sideBtn" *ngIf="isShowSideBtn && subModuleWidgets.length > 0">
    <button pButton pRipple type="button" [pTooltip]="mainModule?.name" tooltipPosition="right" class="p-button-rounded"
      [label]="mainModule?.name.charAt(0).toUpperCase()" (click)="navigateToMainModule()" style="margin-bottom: 10px;" *ngIf="isShowSideBtn"
      [ngClass]="{'p-button-secondary': !activeNavigation.module}"></button>
    <!-- Submodule Navigation Buttons -->
    <button *ngFor="let subModule of subModuleWidgets" pButton pRipple type="button"
      [pTooltip]="subModule.name" tooltipPosition="right"
      class="p-button-rounded" [label]="subModule.name.charAt(0).toUpperCase()"
      (click)="navigateToSubModule(subModule)" style="margin-bottom: 10px;"
      [ngClass]="{'p-button-secondary': activeNavigation.subModuleId !== subModule.id}"></button>
  </div>
  <ng-container *ngIf="showSubModuleWidgets && selectedSubModule; else existingModule">
    <app-dynamic-table [style.width]="isShowSideBtn ? 'calc(100% - 53px)' : '100%'" *ngIf="selectedSubModule?.id"
      [isCustomModule]="true"
      [workbookId]="selectedSubModule.referenceId"
      [isLeftTableHide]="false"
      [isShowSideBtn]="isShowSideBtn"
      [isSubModuleWidgets]="subModuleWidgets && subModuleWidgets.length > 0"
      (isChangeSideBtn)="changeSideHeader()">
    </app-dynamic-table>
  </ng-container>
  <ng-template #existingModule>
    <app-dynamic-table [style.width]="isShowSideBtn && subModuleWidgets.length > 0 ? 'calc(100% - 53px)' : '100%'" *ngIf="customModuleWBId"
      [isCustomModule]="true"
      [workbookId]="customModuleWBId"
      [isLeftTableHide]="false"
      [isShowSideBtn]="isShowSideBtn"
      [isSubModuleWidgets]="subModuleWidgets && subModuleWidgets.length > 0"
      (isChangeSideBtn)="changeSideHeader()">
    </app-dynamic-table>
  </ng-template>
</div>
